import { Accordion, AccordionDetails, styled } from '../../../../base';

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
    '&::before': {
        display: 'none',
    },
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-of-type': {
        borderBottom: 'none',
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
        marginBottom: theme.spacing(0.5),
    },
    '& .MuiTypography-root': {
        unicodeBidi: 'plaintext',
        textAlign: theme.direction === 'rtl' ? 'right' : 'left',
    },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
    padding: theme.spacing(0, 2, 1.5),
}));
